//WHERE ARE MY PAGES NATHANIEL ... I NEED MY PAGES NATHANIEL

import Main from "./components/main";
import Initscreen from "./components/initscreen";
import Content from "./components/content";
import ErrorPage from "./components/error";
import Cookies from "universal-cookie";
import Contentlist from "./components/Contentlisting";
import Loading from "./components/loading";
import Admin from "./components/admin";

//import the router
import { NavLink, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

const cookies = new Cookies();
const watched = cookies.get("watched");
let homepage = <Main />;
console.log(watched);


if (!watched || watched === "undefined") {
  cookies.set("watched", "true");
  homepage = <Initscreen />;
}

function App() {
  return (
    <ErrorBoundary FallbackComponent={<ErrorPage />}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/initscreen" element={<Initscreen />} />
          <Route path="/Content" element={<Content />} />
          <Route path="/contentlist" element={<Contentlist />} />
          <Route path="/loading" element={<Loading />} />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <ErrorPage
                error="Error - 404"
                information="Unkown request please return to homepage at Projectshard.xyz"
              />
            }
          />
        </Routes>
    </ErrorBoundary>
  );
}

export default App;
